import React, { useMemo, useState } from "react";
import SearchWithDropdown from "../../components/form/front/SearchWithDropdown";
import Dropdown from "../../components/form/Dropdown";
import Button from "../../components/form/front/Button";
import Select from "../../components/form/front/Select";
import Tabs from "../../components/elements/Tabs";
import { useTabQuery } from "../../hooks/useTabQuery";
import MessagesSection from "../../components/sections/front/MessagesSection";

const Messages = () => {
  const [keyword, setKeyword] = useState("");
  const [value, setValue] = useState(null);

  const profileMenu = [
    {
      _id: 1,
      name: "My Profile",
      icon: "fa-regular fa-user",
      //   link: notificationLink,
    },
    {
      _id: 2,
      name: "Create Company",
      icon: "fa-regular fa-plus",
      //   link: "/manage-company",
    },
    {
      _id: 3,
      name: "Help",
      icon: "fa-regular fa-circle-question",
      //   link: "/help",
    },
  ];

  const formattingOptions = [
    { value: 1, name: "Inbox" },
    { value: 2, name: "Archived" },
  ];

  const handleSelectChange = (value, item) => {
    console.log("Selected Value:", value);
    console.log("Selected Item:", item);
    setValue(value);
  };

  return (
     <section className="flex-1 md:pb-14 xls:pb-28 bg-white shadow dark:bg-darkBg relative w-full sm:px-0 max-w-full md:max-w-3xl lg:max-w-4xl xls:max-w-7xl 2xl:max-w-7xl 3xl:max-w-6xl mx-auto rounded-xl overflow-hidden !pb-0">
        <div className="w-full flex justify-between items-center px-4 border-b bg-slate-100 py-1">

          <div className="flex gap-4 items-center">
            <div className="text-base font-semibold text-gray-900">Messaging</div>

            {/* <div className="w-[70%] hidden md:block">
            <SearchWithDropdown
              placeholder="Search jobs"
              keyword={keyword}
              setKeyword={setKeyword}
              xPlacement="bottom"
              divClasses="shadow-[0_0_2px_rgba(0,0,0,0.16)] dark:text-gray-100 px-3 rounded-md bg-[#edf3f8] shadow-none border-0"
              inputClasses="pr-24 placeholder:text-sm"
              icon="fa-light fa-search"
              iconClasses="text-black text-base dark:text-gray-100 pr-1"
            />
          </div> */}
          </div>

          {/* <div className="flex gap-4 items-center w-1/2 justify-end">
          <Dropdown
            data={profileMenu}
            xPlacement="bottomRight"
            dropdownContainer="w-72"
            buttonClasses="p-0 border-0 !text-xl text-gray-800"
            variantClass="mt-4"
            itemclasses="last:border-b-2"
            button={<i class="fa-solid fa-ellipsis"></i>}
          />
          <Button
            buttonIcon={"fa-regular fa-pen-to-square"}
            buttonClasses={
              "!rounded-full hover:!bg-primary hover:text-white w-11 h-11 !bg-slate-100 text-gray-800 text-lg"
            }
            buttonLabelClasses={"mx-auto !text-xs lg:!text-base"}
            buttonType={"submit"}
          />
        </div> */}
        </div>
        {/* <div className="w-full flex gap-4 justify-between items-center px-4 border-b border-gray-200 py-2">
        <div className="flex gap-4 items-center w-[120px] justify-start">
          <Select
            placeholder={"Inbox"}
            dropdownButtonClass={
              "h-9 rounded-full bg-[#01754f] !text-white font-semibold"
            }
            selectPlaceholder="text-white"
            selectDropdownIcon={"text-white text-bold"}
            dropdownData={formattingOptions}
            onChange={handleSelectChange}
            selectedValue={value}
          />
        </div>
        <div className="border-l border-gray-300 w-full px-4">
          <Tabs
            items={tabs}
            selectedIndex={selectedIndex}
            setSelectedIndex={handleTabChange}
            tabsClass="gap-10 w-full bg-white before:border-b-0"
            underLineClass="hidden"
            tabsButtonsClass="pb-0"
          />
          <Button
            buttonLabel={"Unread"}
            buttonClasses={
              "rounded-full bg-transparent border-gray-400 border-2 text-gray-700 font-bold hover:bg-slate-100 hover:border-gray-600 h-9"
            }
          />
        </div>
      </div> */}
        <div className="flex-1 overflow-hidden">
          <MessagesSection />
        </div>
      </section>
  );
};

export default Messages;
